export const METAMASK_NOT_INSTALLED = 'Please install Metamask.';
export const CHANGE_WALLET_CHAIN = 'Please change network to $i';
export const GENERIC_ERROR = 'Something went wrong.';
export const MINTING_ERROR = 'Sorry, something went wrong please try again later.';
export const MINTING_TOKEN = '`Minting your $i...`';
export const MINT_MESSAGE = 'Click buy to mint your NFT.';
export const SUCCESSFULLY_MINTED = 'WOW, the $i is yours! go visit Opensea.io to view it.';
